module.exports = (context, options) => {
  let ret = '<ul>';

  for (let i = 0, j = context.length; i < j; i++) {
    ret = ret + '<li>' + options.fn(context[i]) + '</li>';
  }

  return ret + '</ul>';
};
